import { CaretDownOutlined } from "@ant-design/icons";
import AddBoxIcon from "@mui/icons-material/AddBox";
import {
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  // Tooltip,
} from "@mui/material";
import { Steps, Tooltip } from "antd";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Select as AntSelect } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EMISSION_DATA_STATUS_TYPE, STEPS } from "../../../constants/enums";
// import { fetchBusinessUnits, industriesService } from '../../services/orgService';
// import { fetchBusinessUnit } from "../../services/orgService";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { neutral, progressBarColor } from "../../../constants/colorConstants";
import { minPageLimit } from "../../../constants/config";
import { MODE, UPLOAD_TYPE } from "../../../constants/enums";
import {
  checkPermissions,
  checkSubscriptionPermission,
  dateParser,
  parseDateMonth,
  toastMessage,
} from "../../../helper";
import {
  discardEmissions,
  getEmissionListService,
  updateEmissionStatus,
  updateEmissionVerifierStatus,
} from "../../../services/emissionService";
import { fetchBusinessUnit } from "../../../services/orgService";
import EmptyList from "../../common/EmptyList";
import ConfirmApproveDialog from "../EmissionApprovalManagement/ConfirmApproveDialog";
import EmissionStatusFilter from "../EmissionApprovalManagement/EmissionStatusFilter";
import EmissionStatusUpdate from "../EmissionApprovalManagement/EmissionStatusUpdate";
import EmissionDetailedView from "../EmissionDetailedView/EmissionDetailedView";
import "./EmissionList.scss";
import ProgressBar from "./ProgressBar/ProgressBar";
import TableFilterSort from "../../common/TableFilterSort";
import SkeletonLoader from "../../common/Skeletons/TableSkeleton/TableSkeletonLoader";
import SubscriptionUpgrade from "../../Subscription/SubscriptionUpgrade";

const progressBarColorMap = [
  "",
  progressBarColor[500],
  progressBarColor[600],
  progressBarColor[700],
];
const { Option } = AntSelect;
const EmissionList = (props: any) => {
  const { t, i18n } = useTranslation();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const planPermissions = useSelector(
    (state: any) => state.sub.subscriptionPermissions
  );
  // const{viewEmissionFlag, id} = props;
  const location = useLocation();
  const { state } = props;
  const currentBusinessUnit = useSelector(
    (state: any) => state.auth.currentBusinessUnit
  );
  const [emissionsList, setemissionsList] = useState([] as any);
  const [statusFilter, setStatusFilter] = useState("");
  const [statusOptions, setStatusOptions] = useState<any>({
    //Removing RFC from dropdown as temporary changes PW-786
    Pending: ["Approved", "Rejected"],
    RFC: ["Approved", "Rejected"],
    Approved: ["Rejected"],
    BulkUpdate: ["Approved"],
    VerifierBulkUpdate: ["Verified"],
  });
  const [allSelected, setAllSelected] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);
  const [emissionsCount, setemissionsCount] = useState(0);
  const [scopeWidthAr, setScopeWidthAr] = useState([] as any);
  const [widthOfScopes, setWidthOfScopes] = useState([] as any);
  const [totalScopeSum, setTotalScopeSum] = useState(0);
  const [openStatusFilter, setOpenStatusFilter] = useState(false);
  const [statusFiltersOptions, setStatusFiltersOptions] = useState([
    //Removing RFC from dropdown as temporary changes PW-786
    ["Pending", false],
    ["Approved", false],
    ["Rejected", false],
  ] as any[]);
  const [directEmissionApproval, setDirectEmissionApproval] = useState(false);
  const [controller, setController] = useState<any>({
    page: 0,
    limit: 10,
    sortBy: null,
    sortOrder: null,
    filters: {},
    columns: {
      Category: {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "Emission ID": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "Value (kg CO2e)": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      Duration: {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "Modified on": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      Status: {
        type: "string",
        hasSortBy: false,
        filterOptions: {
          Pending: {
            value: "Pending",
            selected: false,
          },
          Approved: {
            value: "Approved",
            selected: false,
          },
          Rejected: {
            value: "Rejected",
            selected: false,
          },
        },
        filterName: "statusFilter",
      },
    },
  });
  const [openTableFilterSort, setOpenTableFilterSort] = useState(false);
  const [selectedColumnData, setSelectedColumnData] = useState<any>();
  const showEmissionFilterOptions = (columnName: any) => {
    if (columnName in controller.columns) {
      let selectedColumnData = controller.columns[columnName];
      if (
        selectedColumnData.hasSortBy &&
        Object.keys(selectedColumnData?.filterOptions)?.length === 0
      ) {
        const filterController: any = {
          sortBy: columnName,
        };
        if (controller.sortBy === columnName) {
          filterController["sortOrder"] =
            controller.sortOrder === "ASC" ? "DESC" : "ASC";
        } else {
          filterController["sortOrder"] = "ASC";
        }
        handleFilterAndSort(filterController, true);
      } else {
        selectedColumnData["columnName"] = columnName;
        selectedColumnData["sortBy"] = controller.sortBy;
        selectedColumnData["sortOrder"] = controller.sortOrder;
        setSelectedColumnData(selectedColumnData);
        setOpenTableFilterSort(true);
      }
    }
  };
  const handleFilterAndSort = (filterController: any, directSort: boolean) => {
    const updatedController = {
      ...controller,
      page: 0,
    };
    if (filterController.sortBy && filterController.sortOrder) {
      updatedController.sortBy = filterController.sortBy;
      updatedController.sortOrder = filterController.sortOrder;
    }
    if (filterController.selectedFilters?.length) {
      updatedController.filters[selectedColumnData.columnName] =
        filterController.selectedFilters;
    } else if (
      !directSort &&
      selectedColumnData &&
      updatedController.filters[selectedColumnData.columnName]
    ) {
      delete updatedController.filters[selectedColumnData.columnName];
    }
    setController({ ...updatedController });
    setOpenTableFilterSort(false);
  };
  const [mode, setMode] = useState(MODE.PLAIN);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [updateStatusFormData, setUpdateStatusFormData] = useState({
    comments: "",
    attachments: [],
  });
  const [eachEmissionData, setEachEmissionData] = useState({} as any);
  const [isLoading, setIsLoading] = useState(true);
  const [bulkUpdate, setBulkUpdate] = useState(false);
  const [bulkUpdateStatusData, setBulkUpdateStatusData] = useState({} as any);
  const [detailedSelectIndex, setDetailedSelectIndex] = useState(0);
  const [detailedSelectItem, setDetailedSelectItem] = useState({} as any);
  const [step, setStep] = useState(STEPS.CATEGORYWISE);
  const navigateNext = (increment: number, pageIncrement: number) => {
    if (pageIncrement) {
      setController((prevState: any) => {
        return { ...prevState, page: prevState.page + pageIncrement };
      });
      setDetailedSelectIndex(() =>
        pageIncrement === -1 ? controller.limit - 1 : 0
      );
    } else if (increment) {
      setEachEmissionData({
        status: emissionsList[detailedSelectIndex + increment].status,
        id: emissionsList[detailedSelectIndex + increment].id,
      });
      setDetailedSelectItem(
        () => emissionsList[detailedSelectIndex + increment]
      );
      setDetailedSelectIndex((prevIndex) => prevIndex + increment);
    }
  };

  const [searchText, setSearchText] = useState("");

  const openBulkUpdate = (e: any) => {
    const selectedUnits = emissionsList.filter((each: any) => each.selected);
    const selectedIds = selectedUnits.map((each: any) => each.id);
    const reqObj = {
      id: selectedIds,
      status: EMISSION_DATA_STATUS_TYPE.PENDING,
      toStatus: e || "",
    };
    setBulkUpdateStatusData(reqObj);
    setBulkUpdate(true);
  };
  const handleStatusChange = (e: any, index: any, each: any, from?: any) => {
    const updatedStatus = emissionsList;
    setEachEmissionData({ ...each, toStatus: e || "", index, from });
    setemissionsList([...updatedStatus]);
    setOpenUpdate(true);
  };

  const handleExternalVerifierStatus = (
    e: any,
    index: any,
    each: any,
    fromDetailedView?: any
  ) => {
    if (
      localStorage.getItem("user") != null &&
      JSON.parse(localStorage.getItem("user") || "").role === 7
    ) {
      let fromStatus =
        each.verify_status === null || each.verify_status === "Pending"
          ? "Pending"
          : each.verify_status;
      let toStatus =
        each.verify_status === "Pending" || each.verify_status === null
          ? "Verified"
          : "Pending";
      updateEmissionVerifierStatus({
        emissionIds: [each.id],
        fromStatus: fromStatus,
        toStatus: toStatus,
      })
        .then((res: any) => {
          if (res.data.length) {
            const updatedList = [...emissionsList];
            updatedList[index].verify_status = toStatus;

            setemissionsList(updatedList);

            if (fromDetailedView) {
              const updatedEachEmission = { ...eachEmissionData };
              updatedEachEmission.verify_status = toStatus;

              setEachEmissionData(updatedEachEmission);
            }
          }
        })
        .catch((e: any) => {
          console.log(e);
        });
    }
  };

  const onClickCancel = () => {
    setSearchText("");
    const reqObj = {
      controller: controller,
      searchText: "",
      type: getCapitalizeType(step),
    };
    getEmissionListService(reqObj)
      .then((res) => {
        console.log("api response: ", res.data);
        computeScopeDetails(res.data.summary);
        let emissionList: any = res.data.emissionsList;
        emissionList.map((eachUnit: any) => (eachUnit.selected = false));
        setemissionsList(emissionList);
        setemissionsCount(res.data.total_count);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onClickSearch = () => {
    const reqObj = {
      controller: controller,
      searchText: searchText,
      type: getCapitalizeType(step),
    };
    getEmissionListService(reqObj)
      .then((res) => {
        console.log("api response: ", res.data);
        computeScopeDetails(res.data.summary);
        let emissionList: any = res.data.emissionsList;
        emissionList.map((eachUnit: any) => (eachUnit.selected = false));
        setemissionsList(emissionList);
        setemissionsCount(res.data.total_count);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const handleBulkStatusUpdate = (eachEmissionData?: any, type?: any) => {
    const bunitId =
      localStorage.getItem("currentBusinessUnit") &&
      JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id;
    if (cellColumnsForVerifer === true) {
      const resultData = {
        emissionIds: [...eachEmissionData.id],
        fromStatus: eachEmissionData.status,
        toStatus: eachEmissionData.toStatus,
      };
      updateEmissionVerifierStatus(resultData)
        .then((res: any) => {
          console.log(res);
          if (res && res?.data?.length) {
            if (type === "Bulk") {
              getEmissionData();
              setOpenUpdate(false);
              return;
            }
            setOpenUpdate(false);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      const resultData = {
        emissionIds: [...eachEmissionData.id],
        company:
          localStorage.getItem("company") &&
          JSON.parse(localStorage.getItem("company") || "").id,
        businessUnit: bunitId,
        fromValue: eachEmissionData.status,
        toValue: eachEmissionData.toStatus,
      };
      updateEmissionStatus(resultData)
        .then((res: any) => {
          console.log(res);
          if (res && res?.data?.success) {
            if (type === "Bulk") {
              getEmissionData();
              setOpenUpdate(false);
              return;
            }
            setOpenUpdate(false);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  let cellColumnsForUser = [
    "Category",
    "Emission ID",
    "Value (kg CO2e)",
    "Duration",
    "Modified on",
    "Modified by",
    "Verifier Status",
    "Status",
  ];
  let cellColumnsForExternalVerifier = [
    "Category",
    "Emission ID",
    "Value (kg CO2e)",
    "Duration",
    "Verifier Status",
  ];
  const [cellColumns, setCellColumns] = useState<any>([]);
  const [cellColumnsForVerifer, setCellColumnsForVerifer] =
    useState<any>(false);

  useEffect(() => {
    const from_date =
      localStorage.getItem("from_date") && localStorage.getItem("from_date");
    const to_date =
      localStorage.getItem("to_date") && localStorage.getItem("to_date");
    if (from_date && to_date) {
      setCellColumns(cellColumnsForExternalVerifier);
      setCellColumnsForVerifer(true);
    } else {
      setCellColumns(cellColumnsForUser);
    }
    location?.state?.from === STEPS.CATEGORYWISE && setStep(STEPS.CATEGORYWISE);
    location?.state?.from === STEPS.ASSETS && setStep(STEPS.ASSETS);
    if (localStorage.getItem("currentBusinessUnit")) {
      let prefData = JSON.parse(
        localStorage.getItem("currentBusinessUnit") || ""
      ).id;
      if (prefData) {
        fetchBusinessUnit(prefData).then((res) => {
          setDirectEmissionApproval(
            res.data.businessUnitPreferences.directEmissionApproval
          );
          if (res.data.businessUnitPreferences.directEmissionApproval) {
            setStatusOptions({
              Approved: ["Rejected"],
              BulkUpdate: ["Approved"],
              VerifierBulkUpdate: ["Verified"],
            });
          }
          if (res.data.businessUnitPreferences.directEmissionApproval) {
            delete controller?.columns["Status"]?.filterOptions?.Pending;
          }
        });
      }
    }
  }, [currentBusinessUnit]);
  useEffect(() => {
    const total = totalScopeSum;
    let widthArray: any = [];
    scopeWidthAr.map((each: any) => {
      const wd = each.sum;
      const width = (wd / total) * 100;
      widthArray.push({
        width: width,
        scope: each.scope,
      });
    });
    setWidthOfScopes([...widthArray]);
  }, [scopeWidthAr]);

  // Category  EmissionID, Unit Value ,Address ,Status ,Unit Duration

  const onSelectUnit = (e: any, index: number, eachEmission?: any) => {
    setMode(MODE.SELECTED);
    setDetailedSelectIndex(index);
    setEachEmissionData({ ...eachEmission });
    setDetailedSelectItem(emissionsList[index]);
  };
  useEffect(() => {
    if (location?.state?.viewEmissionFlag === true) {
      selectUnitById(location?.state?.id, emissionsList);
    }
  }, [emissionsList]);
  const selectUnitById = (id: number, emissionList: any) => {
    let idx: number;
    emissionList.map((e: any, index: number) => {
      if (e.id === id) {
        idx = index;
        setMode(MODE.SELECTED);
        setDetailedSelectIndex(idx);
        setDetailedSelectItem(emissionsList[idx]);
      }
    });
  };
  const onClose = () => {
    setMode(MODE.PLAIN);
    location.state.viewEmissionFlag = false;
    navigate("/log/Emissions", {
      state: {
        viewEmissionFlag: false,
      },
    });
  };

  //  "Address"
  const rowsPerPageArray = [10, 25, 50, 100];
  const navigate = useNavigate();
  const addNewEmission = (uploadType: string) => {
    navigate("/log/logemissions", { state: { uploadType: uploadType, step } });
  };
  const globalSelectChange = (e: any) => {
    console.log(e);
    if (cellColumnsForVerifer === true) {
      setAllSelected(e.target.checked);
      let emissionList: any = emissionsList;
      emissionList.map((each: any) => {
        each.selected = each.status !== "Verified" ? e.target.checked : false;
      });
      setemissionsList([...emissionList]);
    } else {
      setAllSelected(e.target.checked);
      let emissionList: any = emissionsList;
      emissionList.map((each: any) => {
        each.selected =
          each.status !== "" && each.status !== "Rejected"
            ? e.target.checked
            : false;
      });
      setemissionsList([...emissionList]);
    }
  };
  const onChangeSelected = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    console.log(e);
    console.log("is button selected?", e.target.checked);
    let emissionList: any = emissionsList;
    emissionList[index]["selected"] = e.target.checked;

    setemissionsList([...emissionList]);
    e.stopPropagation();
  };

  const computeScopeDetails = (summaryInfo: any) => {
    let tempScopeWidthAr: any = [];
    let total = 0;
    summaryInfo.map((elem: any) => {
      total = total + elem.sum;
      tempScopeWidthAr.push({
        sum: elem.sum,
        scope: elem.scope,
      });
    });
    setTotalScopeSum(total);
    setScopeWidthAr([...tempScopeWidthAr]);
  };

  useEffect(() => {
    let reqCount = 0;
    emissionsList.map((bunit: any) => {
      if (bunit["selected"] === true) {
        reqCount += 1;
      }
    });
    setSelectedCount(reqCount);
  }, [emissionsList]);

  const handleRemoveFilters = (index: any) => {
    const currStatusFiltersOptions = statusFiltersOptions;
    currStatusFiltersOptions[index][1] = false;
    setStatusFiltersOptions(currStatusFiltersOptions);
    handleFilter();
  };
  const handleFilter = () => {
    let reqFilterReq = "";
    //take which is checked
    const checkedStatus = statusFiltersOptions.filter((each: any) => each[1]);
    checkedStatus.map((each: any, index: any) => {
      if (each[1]) {
        reqFilterReq += each[0];
      }
      if (index !== checkedStatus?.length - 1) {
        reqFilterReq += ",";
      }
    });
    setOpenStatusFilter(false);
    setStatusFilter(reqFilterReq);
  };
  const getCapitalizeType = (value: any) => {
    if (value === STEPS.CATEGORYWISE) {
      return "Category";
    } else if (value === STEPS.ASSETS) {
      return "Asset";
    }
    return "All";
  };
  const getEmissionData = () => {
    if (location?.state?.type?.length) {
      setStep((step) => location.state.type);
    }
    const reqObj: any = {
      controller: controller,
      type: getCapitalizeType(
        location?.state?.type?.length ? location.state.type : step
      ),
      filter: {},
    };

    if (statusFilter && statusFilter?.length) {
      reqObj["statusFilter"] = statusFilter;
    }
    // reqObj["tab"] = step;

    if (Object.keys(controller?.filters).length > 0) {
      Object.entries(controller?.filters).forEach(
        ([filterKey, filterValues]: any) => {
          if (filterValues.length) {
            const filterName =
              controller.columns[filterKey]?.filterName || filterKey;
            let filterValuesString: string = filterValues?.join(",");
            reqObj.filter[filterName] = filterValuesString;
          }
        }
      );
    }

    searchText !== "" && (reqObj.searchText = searchText);
    setIsLoading(true);
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id
      ? getEmissionListService(reqObj)
          .then((res) => {
            computeScopeDetails(res.data.summary);
            let emissionList: any = res.data.emissionsList || [];
            emissionList.map((eachUnit: any) => (eachUnit.selected = false));
            setAllSelected(false);
            setemissionsList(emissionList);
            setemissionsCount(res.data.total_count || 0);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setIsLoading(false);
          })
      : setIsLoading(false);
  };

  useEffect(() => {
    getEmissionData();
  }, [controller, searchText, currentBusinessUnit, statusFilter, step]);

  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const handleCancel = () => {
    let tempEmissionList: any = emissionsList;
    tempEmissionList.forEach((element: any) => {
      element["selected"] = false;
    });
    setemissionsList([...tempEmissionList]);
    setSelectedCount(0);
  };
  const handleDiscard = () => {
    let tempEmissionList = "";
    emissionsList.forEach((elem: any) => {
      var toReturn = elem;
      if (toReturn.selected === true) {
        toReturn.status = "Discarded";
        toReturn.selected = false;
        tempEmissionList += tempEmissionList ? "," + toReturn.id : toReturn.id;
      }
    });
    discardEmissions({ isDiscard: true, ids: tempEmissionList })
      .then((res) => {
        setSelectedCount(0);
        setController({ ...controller });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = step === STEPS.ASSETS ? false : Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (type?: string) => {
    setAnchorEl(null);
    if (type) {
      addNewEmission(type);
    }
  };

  // const useStyles : any = makeStyles((theme : any) => ({
  //   customTableContainer: {
  //     overflowX: "initial"
  //   }
  // }));
  // const classes = useStyles();
  const styles = (theme: any) => ({
    tableRow: {
      "&:hover": {
        backgroundColor: "green !important",
      },
    },
  });
  const handleNewClick = () => {
    const bunitList = localStorage.getItem("businessUnits");
    !bunitList?.length
      ? toastMessage(
          "Create a Facility first for creating an emission log",
          "error"
        )
      : addNewEmission(UPLOAD_TYPE.MANUAL);
  };
  const handleTabChange = (currTab: any) => {
    setController({
      ...controller,
      page: 0,
      limit: minPageLimit,
    });
    setStep(currTab);

    navigate("/log/emissions", {
      state: {
        type: currTab,
      },
    });
  };
  return (
    <Fragment>
      <div className="h-[4.5rem] justify-start items-center pw-tab-main bg-neutral-100 inline-flex">
        <div
          className="flex-col justify-start items-center gap-2 inline-flex cursor-pointer"
          onClick={() => handleTabChange(STEPS.ALL)}
        >
          <div className="h-5 px-6 justify-center items-center gap-2 inline-flex">
            <div
              className={`text-sm  ${
                step === STEPS.ALL
                  ? "text-green-500 font-bold"
                  : "text-slate-500 font-normal"
              } font-['Proxima Nova'] leading-tight`}
            >
              All
            </div>
          </div>
          <div
            className={`self-stretch h-px border ${
              step === STEPS.ALL ? "border-green-500" : "border-zinc-200"
            }`}
          ></div>
        </div>
        <div
          className="flex-col justify-start items-center gap-2 inline-flex cursor-pointer"
          onClick={() => handleTabChange(STEPS.CATEGORYWISE)}
        >
          <div className="h-5 px-6 justify-center items-center gap-2 inline-flex">
            <div
              className={`text-sm  ${
                step === STEPS.CATEGORYWISE
                  ? "text-green-500 font-bold"
                  : "text-slate-500 font-normal"
              } font-['Proxima Nova'] leading-tight`}
            >
              {/* changing text as per ticket 875 */}
              Facility
            </div>
          </div>
          <div
            className={`self-stretch h-px border ${
              step === STEPS.CATEGORYWISE
                ? "border-green-500"
                : "border-zinc-200"
            }`}
          ></div>
        </div>
        <div
          className="flex-col justify-start items-center gap-2 inline-flex cursor-pointer"
          onClick={() => handleTabChange(STEPS.ASSETS)}
        >
          <div className="h-5 px-6 justify-center items-center gap-2 inline-flex">
            <div
              className={`text-sm  ${
                step === STEPS.ASSETS
                  ? "text-green-500 font-bold"
                  : "text-slate-500 font-normal"
              } font-['Proxima Nova'] leading-tight`}
            >
              Assets
            </div>
          </div>
          <div
            className={`self-stretch h-px border ${
              step === STEPS.ASSETS ? "border-green-500" : "border-zinc-200"
            }`}
          ></div>
        </div>
      </div>
      {step !== STEPS.ALL &&
        !emissionsList?.length &&
        searchText === "" &&
        statusFilter === "" &&
        !isLoading &&
        !Object.keys(controller.filters).length && (
          <div className="pw-empty-page flex flex-col h-100v w-full justify-center items-center gap-5">
            <img
              className="pw-no-items"
              src="assets/images/empty.png"
              alt=" "
            />
            <div>{t("Welcome to Emission Logs page")}</div>
            <div className="pw-bunit-desc">{t("Emission Message")}</div>
            <div className="pw-new-icon flex flex-row gap-3">
              {checkPermissions(["CREATE_EMISSION"], permissions) ? (
                <div className="pw-emission-new pw-add-new cursor-pointer ">
                  <div onClick={handleNewClick}>
                    <AddBoxIcon className="pw-box-icon" />
                    &nbsp;&nbsp;&nbsp;{t("New")}
                  </div>
                  <div
                    className={`${
                      step !== STEPS.ASSETS && "pw-bulkupload"
                    }  mr-2 ml-2 `}
                  ></div>
                  <div className="pw-e2e-addlogmenu">
                    {step !== STEPS.ASSETS && (
                      <ArrowDropDownIcon onClick={handleClick} />
                    )}
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={() => handleClose()}
                      // MenuListProps={{
                      //   "aria-labelledby": "basic-button",
                      // }}
                    >
                      <MenuItem onClick={() => handleClose(UPLOAD_TYPE.MANUAL)}>
                        {t("Manual")}
                      </MenuItem>
                      {!checkSubscriptionPermission(
                        "BULK_UPLOAD",
                        planPermissions,
                        -1
                      ) ? (
                        <MenuItem className="pw-e2e-bulkuploadbtn">
                          <span className="mr-2">{t("Bulk Upload")}</span>
                          <SubscriptionUpgrade />
                        </MenuItem>
                      ) : (
                        <MenuItem
                          className="pw-e2e-bulkuploadbtn"
                          onClick={() => handleClose(UPLOAD_TYPE.BULKUPLOAD)}
                        >
                          {t("Bulk Upload")}
                        </MenuItem>
                      )}
                    </Menu>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        )}

      {(emissionsList?.length ||
        searchText !== "" ||
        statusFilter !== "" ||
        isLoading ||
        Object.keys(controller.filters).length) &&
      mode === MODE.PLAIN ? (
        <div className="pw-elist-main overflow-y-auto !h-full w-full">
          {/* <div className="pw-elist-main overflow-y-auto"> */}
          <div className="pw-progress-header bg-white">
            {isLoading ? (
              <Skeleton height={15} sx={{ bgcolor: neutral[200] }} />
            ) : (
              <div className="pw-bar">
                {widthOfScopes.map((scope: any, id: Number) => {
                  if (id === 0) {
                    return (
                      <ProgressBar
                        percentage={scope.width}
                        color={progressBarColorMap[scope.scope]}
                        position="start"
                      />
                    );
                  } else if (id === widthOfScopes.length - 1) {
                    return (
                      <ProgressBar
                        percentage={scope.width}
                        color={progressBarColorMap[scope.scope]}
                        position="end"
                      />
                    );
                  } else {
                    return (
                      <ProgressBar
                        percentage={scope.width}
                        color={progressBarColorMap[scope.scope]}
                        position="mid"
                      />
                    );
                  }
                })}
              </div>
            )}
            <div className="flex flex-row pw-justify-space-between items-center gap-10">
              {isLoading ? (
                <Skeleton
                  variant="text"
                  height={15}
                  width="10%"
                  sx={{ bgcolor: neutral[200] }}
                />
              ) : (
                <span className="pw-progresstext">
                  {t("Total")}:&nbsp;
                  <span className="pw-progressbold">
                    {parseFloat(String(totalScopeSum)) >= 1000
                      ? (parseFloat(String(totalScopeSum)) / 1000).toFixed(2)
                      : parseFloat(String(totalScopeSum)).toFixed(0)}
                  </span>
                  {parseFloat(String(totalScopeSum)) >= 1000
                    ? " t CO2e"
                    : " kg CO2e"}
                </span>
              )}
              {isLoading ? (
                <div className="flex flex-row gap-5 justify-between w-full pl-40">
                  <Skeleton
                    variant="text"
                    height={15}
                    width="10%"
                    sx={{ bgcolor: neutral[200] }}
                  />
                  <Skeleton
                    variant="text"
                    height={15}
                    width="10%"
                    sx={{ bgcolor: neutral[200] }}
                  />
                  <Skeleton
                    variant="text"
                    height={15}
                    width="10%"
                    sx={{ bgcolor: neutral[200] }}
                  />
                </div>
              ) : (
                <>
                  {widthOfScopes.map((scope: any, idx: number) => {
                    return (
                      <span className="pw-progresstext">
                        <span
                          className={"pw-dot-scope" + `${scope.scope}`}
                        ></span>
                        {`Scope ${scope.scope}: `}
                        <span className="pw-progressbold">
                          {parseFloat(scopeWidthAr[idx]?.sum?.toFixed(2)) >=
                          1000
                            ? (
                                parseFloat(scopeWidthAr[idx]?.sum) / 1000
                              ).toFixed(2)
                            : parseFloat(scopeWidthAr[idx]?.sum?.toFixed(2))}
                        </span>
                        {parseFloat(scopeWidthAr[idx]?.sum?.toFixed(2)) >= 1000
                          ? " t CO2e"
                          : " kg CO2e"}
                        &nbsp; {"(" + parseFloat(scope.width).toFixed(1) + "%)"}
                      </span>
                    );
                  })}
                </>
              )}
              {/* <span className="pw-progresstext">
                  <span className="pw-dot-scope1 "></span>Scope 1 :
                  <span className="pw-progressbold">{scope1}</span> kgCO2e
                </span>
                <span className="pw-progresstext">
                  <span className="pw-dot-scope2"></span>Scope 2 :
                  <span className="pw-progressbold">{scope2}</span> kgCO2e
                </span> */}
            </div>
          </div>
          <div className="pw-blist-header w-full flex flex-row justify-between">
            {/* <FormControl  }} variant="  "> */}
            {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}

            <OutlinedInput
              id="outlined-adornment-password "
              className="pw-search-field"
              placeholder={t("Search")}
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  onClickSearch();
                }
              }}
              endAdornment={
                <InputAdornment position="end">
                  {searchText === "" ? (
                    <IconButton onClick={onClickSearch} edge="end">
                      <SearchIcon />
                    </IconButton>
                  ) : (
                    <IconButton onClick={onClickCancel} edge="end">
                      <CloseIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
            {/* </FormControl>  */}
            {selectedCount === 0 ? (
              <div className="pw-new-icon flex flex-row gap-3">
                {step !== STEPS.ALL &&
                checkPermissions(["CREATE_EMISSION"], permissions) ? (
                  <div className="pw-emission-new pw-add-new cursor-pointer">
                    <div onClick={() => addNewEmission(UPLOAD_TYPE.MANUAL)}>
                      <AddBoxIcon className="pw-box-icon" />
                      &nbsp;&nbsp;&nbsp;{t("New")}
                    </div>
                    <div
                      className={`${
                        step !== STEPS.ASSETS && "pw-bulkupload"
                      }  mr-2 ml-2 `}
                    ></div>
                    <div className="pw-e2e-addlogmenu">
                      {step !== STEPS.ASSETS && (
                        <ArrowDropDownIcon onClick={handleClick} />
                      )}
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={() => handleClose()}
                        // MenuListProps={{
                        //   "aria-labelledby": "basic-button",
                        // }}
                      >
                        <MenuItem
                          onClick={() => handleClose(UPLOAD_TYPE.MANUAL)}
                        >
                          {t("Manual")}
                        </MenuItem>
                        {!checkSubscriptionPermission(
                          "BULK_UPLOAD",
                          planPermissions,
                          -1
                        ) ? (
                          <MenuItem className="pw-e2e-bulkuploadbtn">
                            <span className="mr-2">{t("Bulk Upload")}</span>
                            <SubscriptionUpgrade />
                          </MenuItem>
                        ) : (
                          <MenuItem
                            className="pw-e2e-bulkuploadbtn"
                            onClick={() => handleClose(UPLOAD_TYPE.BULKUPLOAD)}
                          >
                            {t("Bulk Upload")}
                          </MenuItem>
                        )}
                      </Menu>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div className="flex flex-row justify-end w-full gap-4">
                <div
                  className="pw-emission-button-light pw-emission-button-next bg-white  cursor-pointer"
                  onClick={handleCancel}
                >
                  {t("Cancel")}
                </div>
                <div className="pw-emission-button-light pw-emission-button-next pw-border-none  cursor-pointer">
                  <Box>
                    <FormControl
                      fullWidth
                      size="small"
                      className="pw-form-select"
                    >
                      {cellColumnsForVerifer === true ? (
                        <AntSelect
                          dropdownStyle={{
                            minWidth: "8rem",
                            paddingRight: "12px",
                          }}
                          placeholder="Please select"
                          suffixIcon={
                            <CaretDownOutlined className="!pointer-events-none" />
                          }
                          defaultValue="Update Status"
                          value="Update Status"
                          className="pw-status-selection"
                          onChange={openBulkUpdate}
                        >
                          {statusOptions["VerifierBulkUpdate"]?.map(
                            (name: any, index: number) => {
                              return (
                                <Option
                                  value={name}
                                  className={`pw-${name.toLowerCase()}-option pw-status-option-btn pw-bg-primary-200`}
                                >
                                  {name}
                                </Option>
                              );
                            }
                          )}
                        </AntSelect>
                      ) : (
                        <AntSelect
                          dropdownStyle={{
                            minWidth: "8rem",
                            paddingRight: "12px",
                          }}
                          placeholder="Please select"
                          suffixIcon={
                            <CaretDownOutlined className="!pointer-events-none" />
                          }
                          defaultValue="Update Status"
                          value="Update Status"
                          className="pw-status-selection"
                          onChange={openBulkUpdate}
                        >
                          {statusOptions["BulkUpdate"]?.map(
                            (name: any, index: number) => {
                              return (
                                <Option
                                  value={name}
                                  className={`pw-${name.toLowerCase()}-option pw-status-option-btn pw-bg-primary-200`}
                                >
                                  {name}
                                </Option>
                              );
                            }
                          )}
                        </AntSelect>
                      )}
                    </FormControl>
                  </Box>
                </div>
                {/* {selectedCount === 1 ? (
                  <Fragment>
                    <div className="pw-emission-button-light pw-emission-button-next bg-white">
                      Clone
                    </div>
                    <div className="pw-emission-button-light pw-emission-button-next bg-white">
                      Edit
                    </div>
                  </Fragment>
                ) : (
                  ""
                )} */}
              </div>
            )}
          </div>
          {statusFiltersOptions.filter((each) => each[1]).length > 0 && (
            <div className="flex gap-x-4 items-center mb-2">
              <div className="pw-text-neutral-700 pw-text-12px">Filters:</div>
              <div className="flex pw-bg-filter-selected rounded pw-text-12px pw-text-neutral-700 p-1 gap-x-1">
                <div>Status: </div>
                {statusFiltersOptions.map((each: any, index: any) => {
                  if (each[1]) {
                    return (
                      <div>
                        <div className="flex gap-x-2">
                          {each[0]}{" "}
                          <img
                            src="assets/icons/close-circle.svg"
                            onClick={() => handleRemoveFilters(index)}
                            style={{ width: "15px", height: "15px" }}
                          />
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          )}
          {isLoading ? (
            <SkeletonLoader type="text" cells={cellColumns} />
          ) : (
            <Fragment>
              {emissionsList?.length ||
              Object.keys(controller.filters).length ? (
                <div className="h-70v pw-hide-scroll overflow-y-auto">
                  <TableContainer className="pw-tablecontainer">
                    <Table size="small">
                      <TableHead>
                        <TableRow className="h-14">
                          <TableCell className="pw-checkbox-width bg-neutral-50">
                            {!cellColumnsForVerifer &&
                            checkPermissions(
                              ["UPDATE_EMISSION_STATUS"],
                              permissions
                            ) &&
                            !directEmissionApproval ? (
                              <Checkbox
                                className="pw-emission-check"
                                checked={allSelected}
                                indeterminate={
                                  !allSelected && selectedCount > 0
                                }
                                onChange={(e: any) => globalSelectChange(e)}
                              />
                            ) : (
                              ""
                            )}
                          </TableCell>
                          {cellColumnsForVerifer === true && (
                            <TableCell className="pw-checkbox-width bg-neutral-50">
                              <Checkbox
                                className="pw-emission-check"
                                checked={allSelected}
                                indeterminate={
                                  !allSelected && selectedCount > 0
                                }
                                onChange={(e: any) => globalSelectChange(e)}
                              />
                            </TableCell>
                          )}

                          {cellColumns.map((eachCell: any, index: any) => (
                            <TableCell
                              key={index}
                              className={`pw-thead-list ${
                                eachCell === "Category" ? "pw-row" : ""
                              } ${
                                eachCell === "Modified On" ? "pw-date-row" : ""
                              } bg-neutral-50 
                          ${
                            controller.sortBy === eachCell ||
                            (controller.filters[eachCell] &&
                              Object.keys(controller.filters[eachCell])?.length)
                              ? "!bg-neutral-200 cursor-pointer"
                              : controller?.columns?.[eachCell] &&
                                emissionsList?.length
                              ? "pw-head-emission-bg cursor-pointer"
                              : ""
                          } pw-thead-list`}
                              align={`${
                                eachCell === "EmissionID" ||
                                eachCell === "Value(kg CO2e)"
                                  ? "right"
                                  : "left"
                              }`}
                              id={eachCell + "-th"}
                              onClick={() => {
                                return emissionsList?.length
                                  ? showEmissionFilterOptions(eachCell)
                                  : Object.keys(controller.filters[eachCell])
                                      ?.length
                                  ? showEmissionFilterOptions(eachCell)
                                  : "";
                              }}
                            >
                              <div className="flex flex-row items-center gap-1">
                                {
                                  <Tooltip
                                    title={`${
                                      emissionsList?.length
                                        ? controller?.columns?.[eachCell] &&
                                          Object.keys(
                                            controller?.columns?.[eachCell]
                                              ?.filterOptions
                                          )?.length
                                          ? "Filter by " + eachCell
                                          : controller?.columns?.[eachCell]
                                              ?.hasSortBy
                                          ? "Sort by " + eachCell
                                          : ""
                                        : ""
                                    }`}
                                    arrow={false}
                                    placement="bottomLeft"
                                  >
                                    <div>{eachCell}</div>
                                  </Tooltip>
                                }

                                {eachCell != " " &&
                                  controller.sortBy === eachCell &&
                                  // <img
                                  //   src={
                                  //     controller.sortOrder === "ASC"
                                  //       ? "assets/icons/sort_alphabetical_ascending.svg"
                                  //       : "assets/icons/sort_alphabetical_descending.svg"
                                  //   }
                                  //   alt=""
                                  // />
                                  (controller.sortOrder === "ASC" ? (
                                    <Tooltip
                                      title={`${
                                        emissionsList?.length
                                          ? "Ascending Order - Click to sort in descending order"
                                          : ""
                                      }`}
                                      placement="bottomLeft"
                                      arrow={false}
                                    >
                                      <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title="Descending Order - Click to sort in ascending order"
                                      placement="bottomLeft"
                                      arrow={false}
                                    >
                                      <ArrowDownwardIcon
                                        sx={{ fontSize: 16 }}
                                      />
                                    </Tooltip>
                                  ))}
                                {controller?.columns?.[eachCell] &&
                                Object.keys(
                                  controller?.columns?.[eachCell]?.filterOptions
                                )?.length ? (
                                  <img
                                    src="assets/icons/filter-variant.svg"
                                    alt=""
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {emissionsList?.length ? (
                        <TableBody className="cursor-pointer">
                          {emissionsList.map(
                            (eachEmission: any, index: number) => (
                              <TableRow
                                key={eachEmission.id}
                                onClick={(e) =>
                                  onSelectUnit(e, index, eachEmission)
                                }
                                className={`pw-selected-row-${eachEmission.selected} bg-white `}
                                hover
                                sx={styles}
                              >
                                <TableCell
                                  onClick={(e) => e.stopPropagation()}
                                  className="pw-emission-width"
                                >
                                  {!cellColumnsForVerifer &&
                                  checkPermissions(
                                    ["UPDATE_EMISSION_STATUS"],
                                    permissions
                                  ) &&
                                  !directEmissionApproval ? (
                                    <Checkbox
                                      disabled={
                                        eachEmission.status === "Approved" ||
                                        eachEmission.status === "Rejected"
                                      }
                                      className="pw-emission-check"
                                      checked={eachEmission.selected}
                                      onChange={(e: any) =>
                                        onChangeSelected(e, index)
                                      }
                                    />
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                                {cellColumnsForVerifer === true && (
                                  <TableCell
                                    onClick={(e) => e.stopPropagation()}
                                    className="pw-emission-width"
                                  >
                                    <Checkbox
                                      disabled={
                                        eachEmission.verify_status ===
                                        "Verified"
                                      }
                                      className="pw-emission-check"
                                      checked={eachEmission.selected}
                                      onChange={(e: any) =>
                                        onChangeSelected(e, index)
                                      }
                                    />
                                  </TableCell>
                                )}
                                <TableCell className="pw-row">
                                  {eachEmission.code +
                                    " " +
                                    eachEmission.category}
                                </TableCell>
                                <TableCell align="right">
                                  {" "}
                                  {eachEmission.emission_code || "-"}{" "}
                                </TableCell>
                                <TableCell align="center">
                                  {eachEmission.value
                                    ? parseFloat(eachEmission.value).toFixed(2)
                                    : 0}
                                </TableCell>
                                <TableCell>
                                  {" "}
                                  {parseDateMonth(eachEmission.from_date) ||
                                    "-"}{" "}
                                </TableCell>
                                {!cellColumnsForVerifer && (
                                  <TableCell className="pw-date-row">
                                    {(eachEmission.last_updated && (
                                      <p>
                                        {eachEmission.last_updated &&
                                          dateParser(eachEmission.last_updated)}
                                      </p>
                                    )) ||
                                      "-"}
                                  </TableCell>
                                )}
                                {!cellColumnsForVerifer && (
                                  <TableCell>
                                    {eachEmission.last_updated_by_name || "-"}
                                  </TableCell>
                                )}

                                {/* {cellColumnsForVerifer === true && ( */}
                                <TableCell onClick={(e) => e.stopPropagation()}>
                                  <Checkbox
                                    // {...label}
                                    icon={<CircleOutlinedIcon />}
                                    checkedIcon={<CheckCircleIcon />}
                                    onChange={(event: any) =>
                                      handleExternalVerifierStatus(
                                        event,
                                        index,
                                        eachEmission,
                                        false
                                      )
                                    }
                                    checked={
                                      eachEmission.verify_status === "Verified"
                                        ? true
                                        : false
                                    }
                                  />
                                </TableCell>
                                {/* )} */}
                                {/* <TableCell> {eachEmission.address || "-"} </TableCell> */}
                                {/* <TableCell> {!eachEmission.disabled ? "Active" : "Inactive"} </TableCell> */}
                                {!cellColumnsForVerifer ? (
                                  <TableCell
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <span
                                      className={` pw-status-dropdown-${
                                        eachEmission.status
                                      } pw-${eachEmission.status?.toLowerCase()}`}
                                    >
                                      {eachEmission.status ===
                                        EMISSION_DATA_STATUS_TYPE.REJECTED ||
                                      !(eachEmission.status ===
                                      EMISSION_DATA_STATUS_TYPE.APPROVED
                                        ? checkPermissions(
                                            ["UPDATE_APPROVED_EMISSIONS"],
                                            permissions
                                          )
                                        : checkPermissions(
                                            ["UPDATE_EMISSION_STATUS"],
                                            permissions
                                          )) ? (
                                        <div
                                          className={`pw-${eachEmission.status.toLowerCase()}-option pw-status-option-btn font-bold pw-bg-primary-200`}
                                        >
                                          {eachEmission.status}
                                        </div>
                                      ) : (
                                        <Box>
                                          <FormControl
                                            fullWidth
                                            size="small"
                                            className="pw-form-select"
                                          >
                                            <AntSelect
                                              placeholder="Please select"
                                              dropdownStyle={{
                                                minWidth: "8rem",
                                                paddingRight: "12px",
                                              }}
                                              suffixIcon={
                                                <CaretDownOutlined className="!pointer-events-none" />
                                              }
                                              value={eachEmission?.status}
                                              className="pw-status-selection"
                                              onChange={(event: any) => {
                                                handleStatusChange(
                                                  event,
                                                  index,
                                                  eachEmission
                                                );
                                              }}
                                            >
                                              {statusOptions[
                                                eachEmission.status
                                              ]?.map(
                                                (name: any, index: number) => {
                                                  return (
                                                    <Option
                                                      value={name}
                                                      className={` pw-margin-10 font-bold pw-${name.toLowerCase()}-option`}
                                                    >
                                                      {name}
                                                    </Option>
                                                  );
                                                }
                                              )}
                                            </AntSelect>
                                          </FormControl>
                                        </Box>
                                      )}
                                    </span>
                                  </TableCell>
                                ) : (
                                  ""
                                )}
                                {/* <TableCell> {eachEmission.registrationId || "-"} </TableCell> */}
                              </TableRow>
                            )
                          )}
                        </TableBody>
                      ) : (
                        " "
                      )}
                    </Table>
                  </TableContainer>
                  {!emissionsList?.length ? (
                    <div className="flex justify-center items-center h-full bg-white">
                      No results found
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <EmptyList cellColumns={cellColumns} />
              )}

              {emissionsList?.length >= 10 || controller.page > 0 ? (
                <TablePagination
                  style={{ overflowY: "hidden" }}
                  className="flex justify-end items-center pw-pagination"
                  component="div"
                  onPageChange={handlePageChange}
                  page={controller.page}
                  count={emissionsCount}
                  rowsPerPage={controller.limit}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage=""
                  rowsPerPageOptions={rowsPerPageArray}
                />
              ) : (
                ""
              )}
            </Fragment>
          )}
        </div>
      ) : (
        ""
      )}

      {(emissionsList?.length || searchText !== "") &&
      mode === MODE.SELECTED ? (
        <div className="pw-blist-main-selected  h-90v flex flex-row">
          <div className="flex flex-col w-1/3 bg-neutral-200 pw-width-side">
            <div className="h-full pw-select-side-list overflow-y-auto flex flex-col w-45 gap-0.5">
              <div className="flex flex-row justify-between pw-padding-side-2 gap-4">
                <OutlinedInput
                  id="outlined-adornment-password "
                  className="pw-search-field pw-search-field-2"
                  placeholder={t("Search")}
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      onClickSearch();
                    }
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {searchText === "" ? (
                        <IconButton onClick={onClickSearch} edge="end">
                          <SearchIcon />
                        </IconButton>
                      ) : (
                        <IconButton onClick={onClickCancel} edge="end">
                          <CloseIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  }
                />
              </div>
              {emissionsList?.length ? (
                emissionsList.map((eachEmission: any, index: number) => (
                  <div
                    className={`flex flex-row cursor-pointer pw-blist-card ${
                      detailedSelectItem?.id === eachEmission.id
                        ? "bg-neutral-100"
                        : "bg-white"
                    }`}
                    key={eachEmission.id}
                    onClick={(e) => onSelectUnit(e, index)}
                  >
                    {/* <div className="flex items-center">
                    <img className="h-9" src="assets/icons/EmptyBunit.svg" />
                  </div> */}
                    <div className="flex flex-col">
                      <div className="pw-bunit-name font-medium text-sm pb-2">
                        {eachEmission.code}&nbsp;{eachEmission.category}
                      </div>
                      <div className="pw-bunit-incharge text-neutral-900 text-sm font-bold">
                        {eachEmission.value
                          ? parseFloat(eachEmission.value).toFixed(2)
                          : 0}
                        &nbsp;kg CO2e
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <EmptyList cellColumns={cellColumns} />
              )}
            </div>

            {emissionsList?.length >= 10 || controller.page > 0 ? (
              <TablePagination
                component="div"
                count={emissionsCount}
                page={controller.page}
                colSpan={5}
                onPageChange={handlePageChange}
                rowsPerPage={controller.limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage=""
                className="flex flex-row justify-end pw-pagination"
              />
            ) : (
              ""
            )}
          </div>
          {emissionsList?.length ? (
            <EmissionDetailedView
              eachEmissionData={eachEmissionData}
              handleStatusChange={handleStatusChange}
              handleExternalVerifierStatus={handleExternalVerifierStatus}
              statusOptions={statusOptions}
              bunitData={detailedSelectItem}
              currentIndex={detailedSelectIndex}
              controller={controller}
              total_count={emissionsCount}
              cellColumnsForVerifer={cellColumnsForVerifer}
              navigateNext={navigateNext}
              setController={setController}
              onClose={onClose}
              id={detailedSelectItem?.id}
              tab={step}
            />
          ) : (
            <EmptyList detailedView={true} />
          )}
          {/* <BusinessUnitDetailedView
                  bunitData={detailedSelectItem}
                  currentIndex={detailedSelectIndex}
                  controller={controller}
                  total_count={bunitsCount}
                  navigateNext={navigateNext}
                  setController={setController}
                  onClose={onClose}
                /> */}
        </div>
      ) : (
        ""
      )}
      {openUpdate && (
        <EmissionStatusUpdate
          setEachEmissionData={setEachEmissionData}
          eachEmissionData={eachEmissionData}
          setemissionsList={setemissionsList}
          emissionList={emissionsList}
          updateStatusFormData={updateStatusFormData}
          setUpdateStatusFormData={setUpdateStatusFormData}
          setOpenUpdate={setOpenUpdate}
        />
      )}
      {openStatusFilter && (
        <EmissionStatusFilter
          directEmissionApproval={directEmissionApproval}
          handleFilter={handleFilter}
          setStatusFilter={setStatusFilter}
          statusFiltersOptions={statusFiltersOptions}
          setStatusFiltersOptions={setStatusFiltersOptions}
          statusFilter={statusFilter}
          getEmissionData={getEmissionData}
          openStatusFilter={openStatusFilter}
          setOpenStatusFilter={setOpenStatusFilter}
        />
      )}
      {bulkUpdate && (
        <ConfirmApproveDialog
          warningType={bulkUpdateStatusData?.toStatus}
          setWarningType={setBulkUpdate}
          bulkUpdateStatusData={bulkUpdateStatusData}
          handleBulkStatusUpdate={handleBulkStatusUpdate}
        />
      )}
      {openTableFilterSort && (
        <TableFilterSort
          selectedColumnData={selectedColumnData}
          openTableFilterSort={openTableFilterSort}
          setOpenTableFilterSort={setOpenTableFilterSort}
          handleFilterAndSort={handleFilterAndSort}
          filter={controller.filters}
        />
      )}
    </Fragment>
  );
};
// const mapStateToProps = (state: any) => {
//   return {
//     currentBusinessUnit: state.auth.currentBusinessUnit,
//   };
// };
export default EmissionList;
